import { render } from "./perpres.vue?vue&type=template&id=73f4803a&scoped=true"
import script from "./perpres.vue?vue&type=script&lang=js"
export * from "./perpres.vue?vue&type=script&lang=js"

import "./perpres.vue?vue&type=style&index=0&id=73f4803a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f4803a"]])

export default __exports__